<template>
	<div class="amount" :class="productType=='DFVIP'?'current':''">
		<div class="title" v-text="productType=='DFVIP'?'DF.VIP':'Funpera'"></div>
		<div class="loan">
			<span>Loan Amount</span>
			<span v-text="'PHP '+ amount" ></span>
		</div>
		<a @click="apply" :class="productType=='DFVIP'?'active':''">Apply</a>
	</div>
</template>

<script>
import NP from 'number-precision';
export default{
    data(){
        return {
			amount: 5000,
        }
    },
	
	props:{
		userInfo:{
			type:Object,
			default:()=>{}
		},
		
		productType:{
			type:String,
			default:""
		}
	},
	watch:{
		userInfo:{
			handler(val){
				if(this.productType == "DFVIP"){
					this.amount = val.vipAmount || 20000;
				}else{
					this.amount = val.amount || 20000;
				}
			},
			immediate: true,
			deep: true
		}
	},

    methods:{
		apply(){
			if(this.userInfo.status == "5"){//进件完成
				location.href = "./loan.html?productType="+this.productType
			}
			else if(this.userInfo.status == "6"){//注册完成
				if(this.productType == "DFVIP" && !(this.userInfo.onTheWayVipOrder && this.userInfo.onTheWayVipOrder.status)){//vip产品
					location.href = "./loan.html?productType="+this.productType
				}
				else if(this.productType == "DF" && !(this.userInfo.onTheWayOrder && this.userInfo.onTheWayOrder.status)){//经提交完资料了，无订单
					location.href = "./loan.html?productType="+this.productType
				}
			}
		}
    }
}
</script>
<style scoped>
.amount{box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);border-radius: 0.2rem;margin: 0 0.3rem 0.3rem 0.3rem;padding: 0 0.4rem 0.3rem 0.4rem;color: #FF8F1F;background: #fff}
.current{color:#667FFB}
.amount .title{text-align: center;font-size: 0.5rem; font-weight: bolder;} 
.amount .loan{margin: 0.2rem 0;display: flex;justify-content: space-between;align-items: center;font-size: 0.34rem;font-weight: bold;}
.amount a{width: 3.32rem; height: 0.8rem; line-height: 0.8rem; text-align: center; font-size: 0.32rem; color: #FFF; background-color: #FF8F1F; border-radius: 0.2rem; box-shadow: 0px 3px 15px rgba(104, 141, 254, 0.39); display: block; margin: 0.22rem auto 0 auto;}
.amount .active{background-color:#667FFB}
</style>
